import { render, staticRenderFns } from "./ToolsMenu.vue?vue&type=template&id=070bb996"
import script from "./ToolsMenu.vue?vue&type=script&lang=ts"
export * from "./ToolsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports